import HeaderProgress from "@components/Progress/HeaderProgress";
import { calculatePensionsCost } from "@utils/calculator";
import React, { useCallback, useEffect, useState } from "react";
import Loading from "../../components/layout/Loading";
import PensionStepOne from "./PensionStepOne";
import PensionStepTwo from "./PensionStepTwo";

type PensionStepProps = {};

export type ObjectDataProps = {
  saving: number;
  enjoy_retirement: number;
  current_age: number;
  retirement_age: number;
  current_pension_fund: string;
};

const PensionStep: React.FC<PensionStepProps> = () => {
  const [step, setStep] = useState(1);
  const [loading, setLoading] = useState(false);
  const [calculationResults, setCalculationResults] = useState<any>(null);

  const onNextCallback = useCallback((objectData: ObjectDataProps) => {
    const calculatedResults = calculatePensionsCost(
      objectData.current_age,
      objectData.retirement_age,
      objectData.enjoy_retirement,
      1,
      parseFloat(objectData.current_pension_fund)
    );

    setCalculationResults(calculatedResults);

    setLoading(true);
    setStep(2);
  }, []);

  useEffect(() => {
    if (loading) {
      setTimeout(() => {
        setLoading(false);
      }, 4500);
    }
  }, [loading]);

  return (
    <section className="grow flex items-center justify-center border-t-4 border-l-0 md:border-t-0 md:border-l-4 border-[#F4E34E] px-0 md:px-2 lg:px-0">
      <div className="max-w-full md:max-w-[846px] w-full md:rounded-3xl md:border md:border-pn_gray-200">
        <HeaderProgress currentStep={step} totalSteps={2} />

        {!loading && step === 1 && (
          <PensionStepOne onNextCallback={onNextCallback} />
        )}

        {loading && (
          <div className="py-[167px]">
            <Loading
              messages={{
                title: "Calculating...",
                subtitle:
                  "Just a little until we get the right numbers for you",
              }}
            />
          </div>
        )}

        {/* <PensionStepTwo results={calculationResults} /> */}
        {!loading && step === 2 && (
          <PensionStepTwo
            results={calculationResults}
          />
        )}
      </div>
    </section>
  );
};

export default PensionStep;
